import { render } from "./CtaSocials.vue?vue&type=template&id=6895fd1d"
import script from "./CtaSocials.vue?vue&type=script&lang=js"
export * from "./CtaSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__